import { Card } from 'antd';
import React from 'react';
import { useMedia } from 'react-use';
import { BREAKPOINTS } from '../../common/constants';
import EqcTable from './components/EqcTable';

const EqcType = () => {
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);

  return (
    <>
      {!isDesktopViewport && (
        <>
          <div id="eqc-page-header" className="page-header text-primary">
            Checklists
          </div>
          <div id="sub-header" />
        </>
      )}
      <div id="eqc-mobile-card-wrapper" className="mobile-card-wrapper">
        <Card id="eqc-setup-module" className="setup-module">
          <div
            id="eqc-header"
            className="eqc-header d-flex align-center justify-between"
          >
            {isDesktopViewport && (
              <div className="d-flex align-center">
                <div className="eqc-header-title">
                  <h1>Checklists</h1>
                  <div id="sub-header" />
                </div>
                <div id="eqc-selection-bar" />
              </div>
            )}
            <div
              id="eqc-add-search-button"
              className={`eqc-header-buttons d-flex align-center ${
                !isDesktopViewport ? 'width-percent-100' : ''
              }`}
            />
          </div>
          <EqcTable />
        </Card>
      </div>
    </>
  );
};

export default EqcType;
